import type { ComboBoxInputDefinition, FileUploaderDefinition } from '../../types'
import { labelPaddingLimit } from '../carmi/InputUtils/constants'

const isFileUploader = (compProps: any): compProps is FileUploaderDefinition['property'] =>
	compProps.type === 'FileUploaderProperties'

export const getLabelPaddingObject = (
	compProps: ComboBoxInputDefinition['property'] | FileUploaderDefinition['property']
): { '--labelPadding': string } | undefined => {
	const { labelPadding, textAlignment } = compProps as ComboBoxInputDefinition['property']
	const alignment = textAlignment || (isFileUploader(compProps) && compProps.filesAlignment)

	const labelPaddingPx = `${labelPadding}px`
	const labelPaddingLimitPx = `${labelPaddingLimit}px`

	if (alignment === 'left') {
		return {
			'--labelPadding': `0 ${labelPaddingLimitPx} 0 ${labelPaddingPx}`,
		}
	} else if (alignment === 'right') {
		return {
			'--labelPadding': `0 ${labelPaddingPx} 0 ${labelPaddingLimitPx}`,
		}
	}
}

export const getInputHeightInPx = ({
	inputHeightMobile,
	inputHeight,
	height,
	isMobileView,
}: {
	inputHeightMobile: number
	inputHeight: number
	height: number
	isMobileView: boolean
}) => {
	const desktopHeight = inputHeight || height!
	const calculatedInputHeight = isMobileView ? inputHeightMobile || desktopHeight : desktopHeight

	return `${calculatedInputHeight}px`
}
